import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnlockOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
const PRO_TAG_BACKGROUND_COLOR = "#2db7f5";
const ProFooter = observer(()=>/*#__PURE__*/ _jsx("div", {
        className: "notice inline notice-info notice-alt",
        style: {
            margin: "0px 0px 15px",
            textAlign: "left"
        },
        children: /*#__PURE__*/ _jsxs("p", {
            children: [
                __("Thanks for using Real Thumbnail Generator and speeding up thumbnail regeneration."),
                " \xb7",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: `${useStores().optionStore.others.proUrl}&feature=footer`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: __("Learn more about PRO")
                })
            ]
        })
    }));
const ProTag = observer(({ feature })=>{
    const { optionStore: { others: { isPro, proUrl } } } = useStores();
    const open = useCallback(()=>{
        window.open(`${proUrl}&feature=${feature}`);
    }, []);
    return isPro ? null : /*#__PURE__*/ _jsx(Tag, {
        icon: /*#__PURE__*/ _jsx(UnlockOutlined, {}),
        color: PRO_TAG_BACKGROUND_COLOR,
        style: {
            cursor: "pointer"
        },
        onClick: open,
        children: __("Unlock feature")
    });
});
export { ProFooter, ProTag, PRO_TAG_BACKGROUND_COLOR };
